import { seasonScore, computeScore, scoreMeta } from "./scoring";

// per-user vs-coach wins
function vsCoachWins(history) {
  return history.filter((h) => h.lgd < h.coachLGD).length;
}
function vsAiWins(history) {
  return history.filter((h) => h.lgd < h.aiLGD).length;
}

export function userAggregates(mode, history) {
  return {
    score: seasonScore(mode, history),
    played: history.length,
    vsCoach: vsCoachWins(history),
    vsAi: vsAiWins(history),
    seasonLGD: history.reduce((s, h) => s + h.lgd, 0),
  };
}

// build ranked season rows (rivals + you), optionally filtered by league
export function buildSeasonRows(mode, dataset, profile, { leagueId = null, matchday = null } = {}) {
  const rows = [];
  const pushRow = (u, isYou) => {
    const hist = matchday
      ? u.history.filter((h) => h.matchday === matchday)
      : u.history;
    if (matchday && hist.length === 0 && !isYou) return;
    const agg = userAggregates(mode, hist);
    rows.push({
      id: u.id, name: u.displayName, favClubId: u.favClubId,
      score: agg.score, played: agg.played, vsCoach: agg.vsCoach,
      isYou, unranked: isYou && u.history.length === 0,
    });
  };
  dataset.rivals.forEach((r) => {
    if (leagueId && !r.favClubId.startsWith(leagueId)) return;
    pushRow(r, false);
  });
  pushRow(profile, true);

  const meta = scoreMeta(mode);
  const dir = meta.betterIsLower ? 1 : -1;
  const sorted = rows
    .filter((r) => !(r.unranked))
    .sort((a, b) => dir * (a.score - b.score));
  sorted.forEach((r, i) => (r.rank = i + 1));
  const unrankedYou = rows.find((r) => r.unranked);
  return { sorted, unrankedYou };
}

export function userRank(mode, dataset, profile) {
  if (profile.history.length === 0) return null;
  const { sorted } = buildSeasonRows(mode, dataset, profile);
  const me = sorted.find((r) => r.isYou);
  return me ? { rank: me.rank, total: sorted.length } : null;
}
